import React, { Component } from "react";
import { Container, Row, Col, Card, CardHeader, CardBody, FormTextarea } from "shards-react";
import DataTable from 'react-data-table-component';

import PageTitle from "../components/common/PageTitle";
import { Store } from "../flux";

const columns = [
  {
    name: 'Nº',
    selector: 'id',
    maxWidth: "10px"
  },
  {
    name: 'Fecha Ini.',
    selector: 'fecha_ini',
    maxWidth: "50px"
  },
  {
    name: 'Hora Ini.',
    selector: 'hora_ini',
    format: d => d.hora_ini + " Hs.",
    maxWidth: "50px"
  },
  {
    name: 'Fecha Fin',
    selector: 'fecha_fin',
    maxWidth: "50px"

  },
  {
    name: 'Hora Fin',
    selector: 'hora_fin',
    format: d => d.hora_fin + " Hs.",
    maxWidth: "50px"
  },
  {
    name: 'Geolocalización',
    cell: row => (
      <span>
        { `${row.direccion}, ${row.localidad}` }
      </span>
    ),
    maxWidth: "350px"

  },
  {
    name: 'Observaciones',
    selector: 'observaciones',
    maxWidth: "350px"
  }
];

class DetalleInternacionEfectorPage extends Component {

  constructor(props) {

    const efectores= Store.getEfectores()
    const internaciones = Store.getAsociados()
    const { match } = props

    const efector =   efectores.find( efector => Number(match.params.efector_id) === efector.id )
    const internacion =   internaciones.find( internacion => Number(match.params.internacion_id) ===  internacion.pedido )
    const end = Math.floor( Math.random() * (10 - 1) ) + 2
    const visitas = Store.getVisitas().slice(0,end)

    super(props);
    this.state = {
      efector,
      internacion,
      visitas
    }

  }

  render() {
    const { efector, internacion, visitas } = this.state

    if (!efector)
      return null

    return (
      <Container fluid className="main-content-container px-4">
        {/* Page Header */}
        <Row noGutters className="page-header pt-3 mb-2">
          <PageTitle sm="4" title={ '(icono)Efector X - ' + efector.nombre + ' ' + efector.apellido} className="text-sm-left" />
        </Row>

        {/* Default Content */}
          <div>
            <h6> Orden Nº: {internacion.pedido} - Práctica Médica: Terapia Ocupacional</h6>
          </div>
          <Row className="py-3 mb-4">
          <Col>
          <Container fluid className="px-3 mb-4 pt-2 border-top bg-celeste detalle-header">
            <Row >
              <Col className="col-md-3">
                <Row>
                  <Col className="col-md-12">
                    <label className="mb-0">Fecha de Asignación</label>
                    <h6><b>01/08/2019</b></h6>
                  </Col>
                  <Col className="col-md-12">
                    <label className="mb-0">Fecha Hasta</label>
                    <h6><b>21/08/2019</b></h6>
                  </Col>
                </Row>
              </Col>
              <Col className="col-md-3">
                <Row>
                  <Col className="col-md-12">
                    <label className="mb-0">Teléfono 1</label>
                    <h6>{ efector.telefono }</h6>
                  </Col>
                  <Col className="col-md-12">
                    <label className="mb-0">Teléfono 2</label>
                    <h6>{ efector.telefono_1 }</h6>
                  </Col>
                </Row>
              </Col>
              <Col className="col-md-3">
                <label className="mb-0">Especialidad</label>
                <h6>{ efector.especialidad }</h6>
              </Col>
              <Col className="col-md-3">
                <label className="mb-0">Comentario</label>
                <FormTextarea placeholder="Words can be like X-rays if you use them properly..." value="Horario de 8 a 14Hs." />
              </Col>
            </Row>
              </Container>

            <Col className="col-md-3">
            <h6><b>Visitas</b></h6>
            </Col>
               <DataTable
                noHeader={true}
                data={visitas}
                columns={columns}
              />
              </Col>
          </Row>
      </Container>
    );
  }
}

export default DetalleInternacionEfectorPage;
